import { MasterButton, Modal, InputTextMaster } from "App/Component/ui"
import { Grid } from "@material-ui/core"
import React, { useContext } from "react"
import {
  convertToValidPrice,
  defaultToastError,
  formatRupiah,
  isNull,
} from "App/utils/helpers"
import { FormContext } from "../../../../context/FormContext"

const ModalTaxDis = ({ setShowModal, perhitungan }) => {
  const { formData, setFormData } = useContext(FormContext)

  // useEffect(() => {
  //   setFormData({
  //     ...formData,
  //     potongan: convertToValidPrice(formData.potongan2),
  //   });
  // }, [formData.potongan2]);

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (convertToValidPrice(formData.potongan2) <= perhitungan.jumlah) {
      const taxPercentNum = isNull(formData.tax)
        ? 0
        : Math.min(100, parseFloat(String(formData.tax).replace(",", ".")) || 0)
      setFormData({
        ...formData,
        potongan: isNull(formData.potongan2)
          ? 0
          : convertToValidPrice(formData.potongan2),
        tax_percent: taxPercentNum,
      })
      setShowModal(false)
    } else {
      defaultToastError("Jumlah potongan tidak boleh lebih dari jumlah !")
    }
  }

  return (
    <Modal title={"Tax & Potongan"} show={setShowModal} width="30%">
      <form action="POST" onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <InputTextMaster
              name="potongan2"
              label="Potongan dalam Rupiah (Rp)"
              id="potongan2"
              placeholder="0"
              value={formData.potongan2}
              onInput={(e) => {
                let val = e.target.value
                if (!isNull(val)) {
                  setFormData({
                    ...formData,
                    potongan2: formatRupiah(val),
                  })
                } else {
                  setFormData({
                    ...formData,
                    potongan2: val,
                  })
                }
              }}
              error={
                convertToValidPrice(formData.potongan2) > perhitungan.jumlah
              }
              message="Potongan melebihi jumlah !"
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name="tax"
              label="Tax dalam persentase (%)"
              id="tax"
              placeholder="0 - 100"
              value={formData.tax}
              onChange={(e) => {
                const raw = e.target.value
                if (raw === "") {
                  return setFormData({ ...formData, tax: "" })
                }
                if (/^[0-9]*([.,][0-9]*)?$/.test(raw)) {
                  setFormData({ ...formData, tax: raw })
                }
              }}
              error={
                (parseFloat(String(formData.tax).replace(",", ".")) || 0) > 100
              }
              message="Maksimal 100%"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-end"
          alignItems="center"
        >
          <MasterButton
            className={"mt-1"}
            type="submit"
            color={"green"}
            name={"Simpan"}
            size="md"
          />
        </Grid>
      </form>
    </Modal>
  )
}

export default ModalTaxDis
